module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/mango-b2ea6035.webp";